import useSocialProfile from '@/utils/hooks/swr/useSocialProfile';

import { classNames } from '@/utils';
import { BASE, SizesType } from '@/types/utils/sizesType';

import { DefaultAvatar } from '@/components/base/Avatar';
import { CIRCLE, Skeleton, SQUARE } from '@/components/base/Skeleton/Skeleton';

type SocialProfileIndicatorProps = {
    socialProfileId?: number;
    className?: string;
    isLoading?: boolean;
    size?: SizesType;
};

export const SocialProfileIndicator = ({
    socialProfileId,
    className = '',
    isLoading = false,
    size = BASE
}: SocialProfileIndicatorProps) => {
    const { socialProfile, isLoading: isLoadingSocialProfile } = useSocialProfile({
        SPID: socialProfileId
    });

    if (isLoading || isLoadingSocialProfile) {
        return (
            <div className={classNames('flex items-center gap-3', className)}>
                <Skeleton type={CIRCLE} className="size-8" />
                <Skeleton type={SQUARE} className="h-[14px] w-24" />
            </div>
        );
    }

    if (!socialProfile) {
        return null;
    }

    return (
        <div className={classNames('flex items-center gap-3', className)}>
            <div className="relative size-8 h-auto w-auto">
                <DefaultAvatar
                    url={socialProfile.external_api_data?.avatar}
                    fallback={socialProfile.slug?.[0]}
                    profileType={socialProfile.social_network_type}
                    size={size}
                    position="bottom-right"
                />
            </div>
            <div className="flex flex-col justify-center font-GSemiBold text-[12px] leading-[14px] tracking-[-0.3px]">
                <p className="text-icoBlack dark:text-white">{socialProfile.slug}</p>
            </div>
        </div>
    );
};
